import { sizes as defaultSizes } from "../../constants";
import { getImageVariantPath } from "../get-image-variant-path";
import { getSrcSet } from "../get-src-set";
var CONTENTFUL_IMAGE_DOMAIN = 'images.ctfassets.net';
export var getPictureSources = function getPictureSources(_ref) {
  var src = _ref.src,
    _ref$sizes = _ref.sizes,
    _sizes = _ref$sizes === void 0 ? defaultSizes : _ref$sizes,
    defaultSize = _ref.defaultSize;
  if (src !== null && src !== void 0 && src.includes(CONTENTFUL_IMAGE_DOMAIN)) {
    // Contentful assets cannot be resized, so we return the original URL
    return {
      fallback: src,
      srcSet: src,
      srcSetWebP: src
    };
  }
  var fallback = getImageVariantPath({
    src: src,
    size: defaultSize || _sizes[_sizes.length - 1]
  });
  var srcSet = getSrcSet({
    src: src,
    sizes: _sizes
  });
  var srcSetWebP = getSrcSet({
    src: src,
    overrideExtension: '.webp',
    sizes: _sizes
  });
  if (!fallback || !srcSet || !srcSetWebP) {
    return null;
  }
  return {
    fallback: fallback,
    srcSet: srcSet,
    srcSetWebP: srcSetWebP
  };
};